import React, { useEffect, useMemo, useState } from 'react';
import { Guide } from '@/pages/home/components/Guide';
import { getLocale, useSelector, useDispatch, useLocation, history, useIntl } from 'umi';
import { storage } from '@/utils/utils'
import { GUIDE_SYS_DASHBOARD, GUIDE_TYPE_DASHBOARD_TABLEAU } from '@/pages/home/models/guide';
import {
  DASHBOARD_GUIDE_BOX_LIST4,
  DASHBOARD_GUIDE_BOX_LIST4_PATH,
  DASHBOARD_GUIDE_HIDE,
} from '@/pages/home/components/GuideModule/GuideDashboardBox';

import './index.scss';

const GuideTableau = (props: any) => {
  const [currentGuideStep, setCurrentGuideStep] = useState(-3);
  const locale = getLocale();
  const { formatMessage } = useIntl();
  const dispatch = useDispatch();
  const { guideType, userInfo } = useSelector((state: any) => {
    const { guide: { guideType }, home: { userInfo } } = state;
    return {
      guideType,
      userInfo
    }
  });

    // 注意下面两个useEffect不要合并到一起，不然会出现：从头部导航进入新手引导，点击到下一步时，关闭按钮无法关闭，而是返回到第一步
    useEffect(() => {
      if (guideType === GUIDE_TYPE_DASHBOARD_TABLEAU) {
        setCurrentGuideStep(0);
      }
    }, [guideType]);

    useEffect(() => {
      const list = storage.getLocalStorageItem(DASHBOARD_GUIDE_BOX_LIST4) || [];
      const guideHide = storage.getLocalStorageItem(DASHBOARD_GUIDE_HIDE);
      if (userInfo?.openid && !list.includes(userInfo.openid) && !guideHide) {
        setCurrentGuideStep(0);
      }
    }, [userInfo])

  const steps = useMemo(() => {
    return [
      {
        highlightElements: [],
        element: () =>
        document.getElementsByClassName('menu-tableau-daily-report')?.[0],
        hasRadius: false,
        title: formatMessage({id:'guide_tableau_step1_title'}),
        subtitle: formatMessage({id:'guide_tableau_step1_subtitle'}),
        description: formatMessage({id:'guide_tableau_step1_description'}),
        placement: 'right',
        bubbleStyle: { left: '0px', top:'4px' },
      }
    ];
  }, [currentGuideStep,locale]);

  // 流程完成后保存至local storage
  const updateGuideCompletionStatus = () => {
    if (userInfo.openid) {
      const list = storage.getLocalStorageItem(DASHBOARD_GUIDE_BOX_LIST4) || [];
      !list?.includes(userInfo.openid) && list.push(userInfo.openid);
      storage.setLocalStorageItem(DASHBOARD_GUIDE_BOX_LIST4, list);
    }
  };

  const onCloseStep = () => {
    updateGuideCompletionStatus();

    dispatch({
      type: 'guide/save',
      payload: {
        guideSys: GUIDE_SYS_DASHBOARD,
        guideType: '',
      },
    });
  }

  const onFinished = () => {
    updateGuideCompletionStatus();
    
    dispatch({
      type: 'guide/showDashboardGuideModule',
      payload: true,
    });
  }
  return (
    // finishText 根据中英文调整
    <Guide
      hideCount={true}
      current={currentGuideStep}
      onCurrentChange={(
        current: number,
        context: { from: 'start' | 'back' | 'next' | 'finish' | 'cancel' },
      ) => {
        const { from } = context;
        setCurrentGuideStep(current);
        if (from === 'finish') {
          onFinished();
        } else if (from === 'cancel') {
          onCloseStep();
        }
      }}
      visibleCloseBtn
      hideCancelButton
      showBackButton
      nextButtonTheme="primary"
      backText={formatMessage({ id: 'guide_last_step' })}
      nextText={formatMessage({ id: 'guide_next_step' })}
      finishText={formatMessage({ id: 'guide_more_step' })}
      steps={steps}
    />
  );
};

export default () => {
  const location = useLocation();
  return <>
    {DASHBOARD_GUIDE_BOX_LIST4_PATH === location.pathname && <GuideTableau />}
  </>
}
